import * as styles from './runningText.module.css';

interface Props {
  children: React.ReactNode;
}

export function RunningText({ children }: Props) {
  return <div className={styles.root}>{children}</div>;
}
